import { Portal } from 'solid-js/web';

export const SmallCornerDialog = (props: any) => {
    return (
        <Portal mount={document.getElementById('root')!}>
            <div class="fixed bottom-0 right-0 z-[1000]">
                <div class="flex flex-col justify-center items-center absolute bottom-0 right-0 bg-white p-8 rounded-[1rem] shadow-[4px_4px_10px_rgba(0,0,0,0.3)] z-[1000] m-4 w-min">
                    {props.children}
                </div>
            </div>
        </Portal>
    );
};
